module.exports = __webpack_public_path__ + "static/img/about-us.71ea2ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about-us.jpg
// module id = pDTK
// module chunks = 1